export default "__VITE_ASSET__DZlOS4ic__"